import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { InputLabel, MenuItem } from '@mui/material';
import { PmiFormControl } from '../pmi-select/pmi-form-control';
import { PmiSelect } from '../pmi-select';

export const idElectronicCard = '3';

export const idPaperCard = '0';

const list: Array<ItemVM> = [
  {
    id: idPaperCard,
    value: 'Cartacea',
  },
  {
    id: idElectronicCard,
    value: 'Elettronica',
  },
];

interface TypeIndentityCardProps {
  disabled?: boolean;
  value: string;
  onChange: (type?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

const TypeIndentityCardComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Tipo',
  id = 'type-identity-card',
}: TypeIndentityCardProps): React.ReactElement => {
  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeIndentityCardComponent.displayName = 'Type Indentity Card list component';

const TypeIndentityCard = memo(TypeIndentityCardComponent);

export default TypeIndentityCard as typeof TypeIndentityCardComponent;
